const smsToolbar = { options: [] };
const emailToolbar = {
  options: [
    "inline",
    "fontFamily",
    //"fontSize",
    "textAlign",
    "list",
  ],
  inline: {
    options: ["bold", "italic", "underline", "strikethrough"],
  },
  fontFamily: {
    options: [
      "Arial",
      "Georgia",
      "Impact",
      "Tahoma",
      "Times New Roman",
      "Verdana",
    ],
    inDropdown: true,
    dropdownClassName: "custom-font-dropdown",
  },
  /* fontSize: {
    options: [8, 10, 12, 14, 16, 18, 24, 36, 48],
    inDropdown: true,
    dropdownClassName: "custom-font-size-dropdown",
  }, */
  textAlign: {
    options: ["left", "center", "right", "justify"],
    inDropdown: true,
    dropdownClassName: "custom-align-dropdown",
  },
  list: {
    options: ["unordered", "ordered", "indent", "outdent"],
    inDropdown: true,
  },
};

export const toolbars = {
  sms: smsToolbar,
  email: emailToolbar,
};
